import { parseNameLocalesField, resolveLocalizedEntityName } from '../../constants/commerceNameLocales';

/** 解析 /api/wpa-auth/company-branding 回傳，依 UI 語系顯示公司名 */
export function resolveCompanyBrandingName(branding, uiLocale) {
  if (!branding) return '';
  const primary = branding.name ?? '';
  const locales = branding.nameLocales ?? branding.name_locales;
  const resolved = resolveLocalizedEntityName(primary, locales, uiLocale);
  return resolved || primary || '';
}

export function normalizeCompanyBrandingPayload(data) {
  if (!data || typeof data !== 'object') {
    return { name: '', nameLocales: null, logoUrl: null };
  }
  const localesRaw = data.nameLocales ?? data.name_locales;
  const locales = localesRaw && typeof localesRaw === 'object' ? { ...localesRaw } : parseNameLocalesField(localesRaw);
  return {
    name: data.name != null ? String(data.name) : '',
    nameLocales: Object.keys(locales).length ? locales : null,
    logoUrl: data.logoUrl ?? data.logo_url ?? null,
  };
}
